import { createContext } from "react";

export const LoginRelatedContext = createContext();
